import { SnackbarData, SnackbarParameters } from '../../interfaces/Snackbar';
import { SovosSnackbar } from 'mosaic-react';
import React, { useState } from 'react';

const initialState: SnackbarParameters = {
	open: false,
	message: '',
	variant: 'confirmation',
	timeout: 'long',
	onAction: () => {},
	onClose: () => {},
};

const withSnackbar = <P extends object>(Children: React.ComponentType<P & SnackbarData>) => {
	return (props: P) => {
		const [snackbarProps, setSnackbarProps] = useState<SnackbarParameters>(initialState);

		const showSnackbar = ({
			onClose = hideSnackbar,
			onAction = hideSnackbar,
			message = '',
			variant = 'confirmation',
			timeout = 'long',
		}: SnackbarParameters) =>
			setSnackbarProps({
				open: true,
				onClose,
				onAction,
				message,
				variant,
				timeout,
			});

		const hideSnackbar = () => setSnackbarProps(initialState);

		return (
			<>
				<Children {...props} showSnackbar={showSnackbar} hideSnackbar={hideSnackbar} />
				<div>
					<SovosSnackbar {...snackbarProps} />
				</div>
			</>
		);
	};
};

export default withSnackbar;
